import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { getEpicStoreAccountId } from '../../../external_node_modules/@wg/web2clientapi/platform/EpicGamesStore/getEpicStoreAccountId.js';
import { fetchUserInfo, getUserInfo } from '../../../api/user.js';
import { EVENTS } from '../../../constants/events.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { UserEntity } from '../../entity/user.entity.js';
import events from '../../event/index.js';
import { getMockedEpicStoreAccountId } from './utils/mock.js';
import settings from '../../../settings.js';
import { log } from '../../../utils/logger.js';
import { memoizeAsync } from '../../../utils/memoize.js';

function fetchEpicStoreAccountId(useClientMocks) {
    return __awaiter(this, void 0, void 0, function* () {
        if (useClientMocks) {
            return yield getMockedEpicStoreAccountId();
        }
        return yield getEpicStoreAccountId();
    });
}
const retrieveEpicStoreAccountId = memoizeAsync(fetchEpicStoreAccountId.name, fetchEpicStoreAccountId);
function getUser(force = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const userInfoFunc = force ? fetchUserInfo : getUserInfo;
        const [userInfo, accountData] = yield Promise.all([
            userInfoFunc(),
            retrieveEpicStoreAccountId(settings.useClientMocks),
        ]);
        const userEntity = new UserEntity(userInfo.spaCountry, userInfo.country, userInfo.accountId, PLATFORMS.EGS, userInfo.isAccountUncompleted, null, userInfo.regional);
        userEntity.setPlatformUserId(accountData.accountId);
        if (settings.purchaseDisabled) {
            userEntity.disableUserPurchase();
        }
        log('[EGS]', 'User data has been successfully fetched', userEntity, userInfo, accountData);
        events.emit(EVENTS.ACCOUNT_UPDATE, { user: userEntity });
        return userEntity;
    });
}
function isAccountCompleted() {
    return __awaiter(this, void 0, void 0, function* () {
        const userInfo = yield fetchUserInfo();
        log('[EGS]', 'User data has been successfully fetched', userInfo);
        return !userInfo.isAccountUncompleted;
    });
}

export { getUser, isAccountCompleted };
//# sourceMappingURL=user.js.map
